var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8359 6V14H19.8359V22H21.8359V2C19.0759 2 16.8359 4.24 16.8359 6ZM11.8359 9H9.83594V2H7.83594V9H5.83594V2H3.83594V9C3.83594 11.21 5.62594 13 7.83594 13V22H9.83594V13C12.0459 13 13.8359 11.21 13.8359 9V2H11.8359V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnyboard);
export default __webpack_public_path__ + "static/media/anyboard.10394cd59bcb411b06b4e03151a20d23.svg";
export { ForwardRef as ReactComponent };